import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-bold uppercase tracking-wider px-8 py-4 min-h-[48px] w-full md:w-auto rounded transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-cream';
  const variants = {
    primary: 'bg-gold hover:bg-gold-dark text-white',
    secondary: 'bg-sage hover:bg-sage-dark text-white',
    outline: 'border-2 border-gold text-gold hover:bg-gold hover:text-white'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-169">
      {children}
    </button>;
}